<template>
  <table>
    <thead class="thead">
      <tr>
        <th
          v-for="(titleHeader, index) in $tm(
            `page.integration.numbers_table.connected_header`
          )"
          class="th"
          :key="index"
          :class="columnClassList[index]"
        >
          <span class="headed_text">{{ titleHeader }}</span>
        </th>
      </tr>
    </thead>
    <tbody class="tbody" ref="scrollComponent">
      <tr v-for="(number, ind) in numberDataList" :key="number.number">
          <template v-if="number.number !== '0'">
              <td class="number">
                  <div class="number-container">
                      <img
                          class="icon"
                          :src="require(`@/assets/icons/${tableTitle}.svg`).default"
                      />
                      <div class="number_with_tags">
                          <span v-text="number.number" />
                          <BaseTag :tag="number.tags[0]" typeClass="table" />
                      </div>
                  </div>
              </td>
              <td class="integration">
                  <ul v-if="number.integrations.length > 0">
                      <li class="headed_text" v-for="crm in number.integrations">
                          {{ crm === 'kwizbot' ? 'connectiveone' : crm }}
                      </li>
                  </ul>
                  <span v-else>-</span>
              </td>
              <td class="paid_to">
          <span
              :class="{ warning_status: !number.tariff_end_date }"
              v-text="
              number.tariff_end_date ||
              $t('page.integration.numbers_table.connected_numbers.aсtivation_msg')
            "
          />
              </td>
              <td class="tariff">
                  <span v-text="number.tariff || '-'" />
              </td>
              <!-- !! CHECK AND REMOVE -->
              <td class="status" :class="statusNumber(number)?.status">
                  <slot name="status" :number="number" />
              </td>
              <td class="api-keys">
                  <div class="api_key">{{ number.api_key }}</div>
              </td>
              <td class="settings">
                  <slot name="settings" :number="number" />
              </td>
              <td class="actions">
                  <slot name="actions" :number="number"> </slot>
              </td>
          </template>
      </tr>
      <tr v-if="tableStatus">
        <td style="border-bottom: none" :colspan="columnClassList.length">
          <InfoDataTextRecurring :value="tableStatus" height="120px" />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import { ref, onUnmounted } from "vue";
import BaseTag from "@/components/ui/BaseTag.vue";
import InfoDataTextRecurring from "@/components/Recurring/InfoDataTextRecurring.vue";
import statusNumberConfig from "./configs/statusNumberConfig";
import { useInfiniteScroll } from "@vueuse/core";
import { useStore } from "vuex";

// TODO: refactor
const columnClassList = [
  "number",
  "integration",
  "paid_to",
  "tariff",
  "status",
  "api_keys",
  "settings",
  "actions",
];

const store = useStore();

const selectButton = ref("");
const scrollComponent = ref(null);

const props = defineProps({
  numberDataList: {
    type: Array,
    require: true,
  },
  tableTitle: {
    type: String,
    require: true,
  },
  tableType: {
    type: String, // 'visible' || 'invisible'
    require: true,
  },
  // 'loading' | 'noNumbers' | null - null means the list has rows
  tableStatus: {
    type: String,
    default: null,
  },
});

const emits = defineEmits(["loadMore"]);

const { isLoading } = useInfiniteScroll(
  scrollComponent,
  () => {
    if (!props.numberDataList?.length || isLoading.value) return;
    emits("loadMore");
  },
  {
    distance: 50,
    interval: 300,
  }
);

// !! CHECK AND REMOVE
const statusNumber = (num) => {
  const { status, buttonText } = statusNumberConfig(num);
  return { status, buttonText };
};
</script>

<style lang="scss" scoped>
@use "@/styles/table.scss";

.tbody {
  max-height: 300px;
  display: block;
  overflow-x: hidden;
  overflow-y: auto;
}

.tariff {
  width: 120px;
}

.tags {
  margin-left: -10px;
  margin-top: -3px;
  min-width: 130px;
}

.icon {
  margin-top: 4px;
}

.settings {
  padding-left: 0;
  padding-right: 0;
  width: 100px;
}

::-webkit-scrollbar {
  width: 6px;
}
</style>
